export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registration Information"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmed"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Public"])}
}